import React from 'react';

import AggregatedProductAttributesView from '../AggregatedProductAttributesView';

const AggregatedMasterDetails = () => (
  <AggregatedProductAttributesView mode="master" />
);

export default AggregatedMasterDetails;
